import { map } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import asButton from '../decorator/asButton';
import ButtonComponent from './Button';
import IconComponent from './Icon';

const ButtonDropdown = React.memo(({ id, title, icon, classes, items, dropdownPosition }) => {
  return (
    <ButtonComponent id={id} title={title} icon={icon} classes={classes}>
      <ul className="buttonDropdown" data-dropdown-position={dropdownPosition}>
        {map(items, (item) => (
          <li
            id={item.id}
            key={item.id}
            {...asButton(
              item.id,
              item.clickButtonEvent,
              item.clickButtonHandler,
              item.clickButtonArgs
            )}>
            {item.icon && <IconComponent src={item.icon} caption="-" />}
            {item.title && <em>{item.title}</em>}
          </li>
        ))}
      </ul>
    </ButtonComponent>
  );
});

ButtonDropdown.propTypes = {
  classes: PropTypes.string,
  title: PropTypes.string,
  icon: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.object).isRequired
};

ButtonDropdown.defaultProps = {
  classes: 'button',
  title: '',
  icon: ''
};

export default ButtonDropdown;
